import { createReducer, isAsyncThunkAction, isFulfilled } from '@reduxjs/toolkit';
import {
  expandCard,
  collapseCard,
  hideRemovalConfirmation,
  showRemovalConfirmation,
  showCardAddedMessage,
  hideCardAddedMessage,
} from '../actions/ui';
import { IStoreUi } from '../types/StoreState';
import { deleteCard } from '../actions/deleteCard';
import { deletePrimaryCard } from '../actions/deletePrimaryCard';

const initialState: IStoreUi = {
  expandCardId: null,
  showRemovalConfirmation: false,
  showCardAddedMessage: false,
};

export const uiStateReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(expandCard, (state, action) => ({
      expandCardId: action.payload,
      showRemovalConfirmation: false,
      showCardAddedMessage: false,
    }))
    .addCase(collapseCard, (state, action) => ({
      expandCardId: null,
      showRemovalConfirmation: false,
      showCardAddedMessage: false,
    }))
    .addCase(showRemovalConfirmation, (state, action) => {
      state.showRemovalConfirmation = true;
    })
    .addCase(hideRemovalConfirmation, (state, action) => {
      state.showRemovalConfirmation = false;
    })
    .addCase(showCardAddedMessage, (state, action) => {
      state.showCardAddedMessage = true;
    })
    .addCase(hideCardAddedMessage, (state, action) => {
      state.showCardAddedMessage = false;
    })
    .addMatcher(isAsyncThunkAction(deletePrimaryCard, deleteCard), (state, action) => {
      return {
        expandCardId: isFulfilled(action) ? null : state.expandCardId,
        showRemovalConfirmation: false,
        showCardAddedMessage: false,
      };
    }),
);
